import React from 'react'
import PropTypes from 'prop-types'
import { affirmBaseFare, affirmBaseFareExp } from '../../constants'
import AffirmText from './AffirmText'

const isAffirmEligible = ({ minimumRetailPrice }) => {
  let minimumAffirm = affirmBaseFare
  if (minimumRetailPrice < affirmBaseFare) {
    minimumAffirm = affirmBaseFareExp
  }
  return minimumRetailPrice > minimumAffirm
}

const getDataAmount = (price) => Math.ceil(parseFloat(price) * 100)

const AffirmWrapper = ({ price }) => <AffirmText data-test='affirm-text' dataAmount={getDataAmount(price)} />

AffirmWrapper.propTypes = {
  price: PropTypes.number,
}

export { isAffirmEligible, AffirmWrapper }
